<ion-row class="ar-statements-row" [ngClass]="{ 'is-selected': vm?.selected }">
  <ion-col
    [size]="isDesktop ? 0.5 : 1"
    class="checkbox"
    data-cy="ar-statements-row-checkbox"
    (click)="onArStatementRowClick()"
  >
    <span class="dot">
      <ion-icon name="checkmark-outline"></ion-icon>
    </span>
  </ion-col>
  <ion-col
    [size]="isDesktop ? 5.5 : 7"
    class="customer-column"
    data-cy="ar-statements-row-customer-information"
  >
    <div class="customer-content">
      <p data-cy="ar-statements-row-customer-name">
        {{ vm?.customerName | titlecase }}
      </p>
      <p data-cy="ar-statements-row-customer-number">
        #{{ vm?.customerNumber }}
      </p>
    </div>
  </ion-col>

  <ion-col
    class="statement-date-column"
    [class.is-touch]="!isDesktop"
    [size]="isDesktop ? 5.5 : 3"
    data-cy="ar-statements-row-statement-date"
  >
    <p>
      {{ statementDate | date: 'MM/d/yyyy' : 'GMT' }}
    </p>
  </ion-col>

  <ion-col
    [size]="isDesktop ? 0.5 : 1"
    class="buttons-column"
    [class.is-touch]="!isDesktop"
  >
    <div>
      <ion-icon
        color="success"
        name="ellipsis-vertical"
        data-cy="transaction-row-more-options-desktop-tablet-btn"
        (click)="onMoreOptionClick($event)"
      >
      </ion-icon>
    </div>
  </ion-col>
</ion-row>
